export const DISCOUNT_TARGET = {
	ITEM: 'item',
	ORDER: 'order',

} as const;
export type TDiscountTarget = typeof DISCOUNT_TARGET[keyof typeof DISCOUNT_TARGET];
